import { AgGridVue } from "ag-grid-vue3";
import { AllCommunityModule, ModuleRegistry, RowSelectionModule, TooltipModule } from 'ag-grid-community'; 

export default defineNuxtPlugin((nuxtApp) => {
    // Only register if not already registered
    if (!nuxtApp.vueApp._context.components['AgGridVue']) {
        nuxtApp.vueApp.component('AgGridVue', AgGridVue)
        ModuleRegistry.registerModules([AllCommunityModule, RowSelectionModule, TooltipModule]);
    }
})